// --- Zoom Modal Functions ---
window.openZoomView = function(zoomButton) {
  const mediaWrapper = zoomButton.closest('.media_wrapper');
  const mediaEl = mediaWrapper.querySelector('.media_el').cloneNode(true);
  const zoomInner = document.querySelector('.media_zoom_inner');
  const zoomCloseBtn = zoomInner.querySelector('.zoom_close_btn');
  $('body').addClass('zoom_modal_open');
  zoomInner.innerHTML = '';
  if (zoomCloseBtn) zoomInner.appendChild(zoomCloseBtn);
  zoomInner.appendChild(mediaEl);
  const zoomContainer = document.querySelector('.media_zoom_container');
  zoomContainer.classList.remove('always_hidden');
  setTimeout(() => {
    zoomContainer.classList.remove('zoom_hidden');
  }, 100);
};

window.closeZoomModal = function() {
   $('body').removeClass('zoom_modal_open');
  const zoomContainer = document.querySelector('.media_zoom_container');
  zoomContainer.classList.add('zoom_hidden');
  zoomContainer.classList.add('always_hidden');
};

// --- Lazy Thumb Loader ---
(function() {
  var loadedThumbs = false;
  function loadLazyThumbs() {
    if (loadedThumbs) return;
    loadedThumbs = true;
    document.querySelectorAll('.lazy-thumb-placeholder').forEach(function(placeholder) {
      var imgSrc = placeholder.getAttribute('data-img-src');
      var alt = placeholder.getAttribute('data-alt');
      var img = document.createElement('img');
      img.src = imgSrc;
      img.alt = alt;
      img.className = 'product_swiper_thumb_item_img';
      img.width = 100;
      img.height = 100;
      var thumbItem = placeholder.querySelector('.product_swiper_thumb_item');
      if (thumbItem) {
        thumbItem.innerHTML = '';
        thumbItem.appendChild(img);
      }
      placeholder.classList.remove('lazy-thumb-placeholder');
    });
  }
  var events = ['click', 'touchstart', 'keyup', 'keydown'];
  events.forEach(function(event) {
    window.addEventListener(event, loadLazyThumbs, { once: true, passive: true });
  });
})();

// --- Lazy Media Loader ---
(function() {
  var loadedMedia = false;
  function loadLazyMedia() {
    if (loadedMedia) return;
    loadedMedia = true;
    document.querySelectorAll('.lazy-media-placeholder').forEach(function(placeholder) {
      var type = placeholder.getAttribute('data-type');
      var mediaWrapper = placeholder.querySelector('.media_wrapper');
      if (type === 'image') {
        var imgSrc = placeholder.getAttribute('data-img-src');
        var alt = placeholder.getAttribute('data-alt');
        var img = document.createElement('img');
        img.src = imgSrc;
        img.alt = alt;
        img.className = 'media_el';
        img.width = 800;
        img.height = 800;
        mediaWrapper.innerHTML = '';
        mediaWrapper.appendChild(img);
      } else if (type === 'video') {
        var videoSrc = placeholder.getAttribute('data-video-src');
        var previewImg = placeholder.getAttribute('data-preview-img');
        var alt = placeholder.getAttribute('data-alt');
        var mediaLabel = alt || 'Country Charms Set';
      
        var video = document.createElement('video');
        video.setAttribute('playsinline', 'true');
        video.setAttribute('loop', 'loop');
        video.setAttribute('autoplay', 'autoplay');
        video.setAttribute('muted', 'muted');
        video.setAttribute('class', 'media_el');
        video.setAttribute('preload', 'metadata');
        video.setAttribute('aria-label', mediaLabel);
        video.setAttribute('poster', previewImg);
        video.width = 800;
        video.height = 800;
      
        var source = document.createElement('source');
        source.src = videoSrc;
        source.type = 'video/mp4';
        video.appendChild(source);
      
        // Fallback image for browsers that don't support video
        var fallbackImg = document.createElement('img');
        fallbackImg.src = previewImg;
        fallbackImg.alt = mediaLabel;
        video.appendChild(fallbackImg);
      
        mediaWrapper.innerHTML = '';
        mediaWrapper.appendChild(video);
      
        // Play the video after appending
        video.play();
      }
      placeholder.classList.remove('lazy-media-placeholder');
    });
  }
  var events = ['click', 'touchstart', 'keyup', 'keydown'];
  events.forEach(function(event) {
    window.addEventListener(event, loadLazyMedia, { once: true, passive: true });
  });
})();

// --- Placeholder Text Adjuster ---
document.addEventListener('DOMContentLoaded', function() {
  function adjustPlaceholderText() {
    const personalizeInputs = document.querySelectorAll('.personalize_input');
    const isMobile = window.innerWidth <= 575;
    personalizeInputs.forEach(function(input) {
      if (isMobile) {
        input.setAttribute('placeholder', 'Up to 13 characters');
      } else {
        input.setAttribute('placeholder', 'Enter up to 13 characters');
      }
    });
  }
  adjustPlaceholderText();
  window.addEventListener('resize', adjustPlaceholderText);
});

// --- Swiper Init Helper ---
window.initCountryCharmsSwipers = function(selectors) {
  if (!window.Swiper || !selectors) return;
  window.productSwiperThumb = new Swiper(selectors.section + ' .product_swiper_thumb', {
    spaceBetween: 2,
    slidesPerView: 6,
  });
  window.productMainSwiper = new Swiper(selectors.section + ' .product_media_swiper', {
    spaceBetween: 10,
    slidesPerView: 1,
    navigation: {
      nextEl: selectors.section + ' .banner_left_product_slider .product_slide_next',
      prevEl: selectors.section + ' .banner_left_product_slider .product_slide_prev',
    },
    pagination: {
      el: selectors.section + ' .banner_left_product_slider .product_swiper_pagination',
      type: 'fraction',
    },
    thumbs: {
      swiper: window.productSwiperThumb,
    },
  });
  var reviewSwiper = new Swiper(selectors.section + ' .review_swiper', {
    spaceBetween: 10,
    slidesPerView: 1,
    pagination: {
      el: '.review_swiper_pagination',
      clickable: true,
    },
  });
  var reviewSwiperMobile_1 = new Swiper(selectors.section + ' .review_swiper_mobile', {
    spaceBetween: 10,
    slidesPerView: 1,
    pagination: {
      el: selectors.section + ' .review_swiper_pagination_mobile',
      clickable: true,
    },
  });
};
